'use client'

import type { ChainId } from '@morpho-org/blue-sdk'

import { InterfaceChainUtils } from '@morpho-org/dapp-core'

import { useFeatureFlags } from '@/lib/shared/components/FeatureFlagsProvider'

/**
 * Hook that checks if auto-deleverage feature is enabled for a chain.
 * Requires both feature flag and pre-liquidation support on the chain.
 * @param chainId - Chain ID to check support for. Required to avoid silently
 *   falling back to the connected target chain in multi-chain contexts.
 * @returns True if auto-deleverage is available
 */
export const useIsAutoDeleverageEnabled = (chainId: ChainId) => {
  const { autoDeleverage: isAutoDeleverageFeatureEnabled } = useFeatureFlags()

  const isPreLiquidationSupported = InterfaceChainUtils.isPreLiquidationSupported(chainId)

  return isAutoDeleverageFeatureEnabled && isPreLiquidationSupported
}
